import styled from "styled-components";
import { TableVirtuoso } from "react-virtuoso";

export interface ValueColumnProps {
  disabled?: boolean;
  red?: boolean;
  width: number;
}

export const getBackgroundColor = ({ red }: Pick<ValueColumnProps, "red">) => {
  if (red) return "#FDA9A9";
  return "#FFF";
};

export const StyledTableVirtuoso = styled(TableVirtuoso)<{ lite?: boolean }>`
  table {
    width: 100%;
    font-size: 11px;
    table-layout: ${props => props.lite ? "fixed" : "auto"};
    display: ${props => props.lite ? "block" : "table"};
  }

  tr:last-child td:first-child {
    border-bottom: 0.5px solid #808080;
  }
`;

const BaseTd = styled.td`
  height: 23px;
  border: 0.5px solid #808080;
`;

export const TickerColumn = styled(BaseTd)<{ visible?: boolean, disabled?: boolean, lite?: boolean }>`
  min-width: ${props => props.lite ? "156px" : "156px"};
  max-width: ${props => props.lite ? "156px" : "156px"};
  width: ${props => props.lite ? "156px" : "156px"};
  vertical-align: middle;
  padding: 0 10px;
  text-align: left;
  color: ${({ theme }) => theme.darkBlueBackground};
  font-weight: 600;
  border-bottom: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-right: 0;
  border-top: ${props => props.visible ? "0.5px solid #808080" : "0"};
  background-color: ${({ theme, disabled, lite }) =>
    disabled ? theme.lightBlueBackground : getBackgroundColor({})
  };
`;

export const TypeColumn = styled(BaseTd)<{ disabled: boolean, lite?: boolean }>`
  width: 92px;
  min-width: 92px;
  text-align: center;
  color: #808080;
  text-transform: uppercase;
  font-weight: 600;
  background-color: ${({ theme, disabled, lite }) =>
    disabled ? theme.lightBlueBackground : getBackgroundColor({})
  };
`;

export const ChainContainer = styled(BaseTd)<{ disabled: boolean, lite?: boolean }>`
  width: 23px;
  min-width: 23px;
  max-width: 23px;
  padding-right: 2px;
  text-align: center;
  background-color: ${({ theme, disabled, lite }) =>
    disabled ? theme.lightBlueBackground : getBackgroundColor({})
  };
  cursor: pointer;
    
  svg {
    margin: auto;
  }
`;

export const QuickUpdateColumn = styled(BaseTd)`
  width: 23px;
  padding-right: 1px;
  background-color: ${({ theme }) => theme.darkBlueBackground};
  color: #FFF;
  text-align: center;
  cursor: pointer;
`;

export const ArrowContainer = styled.div`
  width: 23px;
  min-width: 23px;
  max-width: 23px;
  display:flex;
  align-items: center;
  justify-content: center;
`;
